import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { TopBarComponent } from "src/app/navigation/top-bar/top-bar.component";
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { SideBarComponent } from "./navigation/side-bar/side-bar.component";
import { TokenInterceptor } from "./core/interceptor/token.interceptor";
import { AuthService } from "./core/authentication/auth.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ScrollbarManager } from "ngx-scrollbar";
import { NgxScrollbarAppModule } from "src/app/shared/modules/ngx-scrollbar-app/ngx-scrollbar-app.module";
import { SmoothScrollManager } from "ngx-scrollbar/smooth-scroll";
import { PopoverConfig, PopoverModule } from "ngx-bootstrap/popover";
import { ModalModule } from "ngx-bootstrap/modal";
import { NavigationModule } from "./navigation/navigation.module";
import { RichTextEditorComponent } from 'src/app/shared/components/rich-text-editor/rich-text-editor.component';
import { UserGuidePreviewComponent } from "./shared/components/user-guide-preview/user-guide-preview.component";
import { UploadResourcesModule } from "./shared/modules/upload-resources/upload-resources.module";
import { DateRangePickerV2Module } from "./shared/modules/date-range-picker-v2/date-range-picker-v2.module";
import { ContentNotificationsModalComponent } from "./shared/components/content-notifications-modal/content-notifications-modal.component";
import {
  BsDatepickerModule,
  BsDatepickerConfig,
  BsDatepickerInlineConfig,
  BsDaterangepickerConfig,
  BsDaterangepickerInlineConfig,
  BsLocaleService,
} from "ngx-bootstrap/datepicker";
import { TooltipConfig, TooltipModule } from "ngx-bootstrap/tooltip";
import { ColorPickerModule } from "ngx-color-picker";
import { CoverAndColorsModalComponent } from "./shared/components/cover-and-colors-modal/cover-and-colors-modal.component";
import { DuplicatePlaybookModalComponent } from "./shared/components/duplicate-playbook-modal/duplicate-playbook-modal.component";
import { LocalStorageService } from "./shared/services/local-storage/local-storage.service";
import { VBuilderAdminModule } from "./v-builder-admin/v-builder-admin.module";
import { EditScheduleReportComponent } from "./company/report/schedule-report/edit-schedule-report/edit-schedule-report.component";
import { SafeHtmlPipeModule } from "src/app/shared/modules/safe-html/safe-html";
import { CK_TOKEN } from "./shared/constants";
import { DndModule } from "ngx-drag-drop";
import { EditresourceComponent } from "./translation/playbook-translation/contents/editresource/editresource.component";
import { RoutebehaviourService } from "./translation/shared/routebehaviour.service";
import { ImportExportComponent } from "./translation/playbook-translation/contents/import-export/import-export.component";
import { EditimageComponent } from "./translation/playbook-translation/contents/editimage/editimage.component";
import { FileUploadModule } from "ng2-file-upload";
import { provideNgxWebstorage, withNgxWebstorageConfig, withLocalStorage, withSessionStorage } from "ngx-webstorage";
import { providePrimeNG } from "primeng/config";
import Aura from "@primeng/themes/aura";
import { NgSelectModule } from "@ng-select/ng-select";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { CustomLoaderService } from "./shared/services/custom-loader/custom-loader.service";
import { AppViewerSharedModule } from "projects/playbook-viewer/src/app/app.module";
import { ConfirmationModalModule } from "./shared/modules/confirmation-modal/confirmation-modal.module";
import { ResourceEmailModule } from "./shared/modules/resource-email/rsource-email.module";
import { LoadSecureAssetsModule } from "./shared/modules/load-secure-assets/load-secure-assets";
import { OnlineSwitchModule } from "./shared/modules/online-switch/online-switch.module";
import { ResourcelandingComponent } from "./shared/components/resourcelanding/resourcelanding.component";
import { SafePipeModule } from "./shared/modules/safe/safe";
import { BrowserSupportComponent } from "./shared/components/browser-support/browser-support.component";
import { PageNotFoundModule } from "./shared/modules/page-not-found/page-not-found.module";
import { PlaybooksModule } from "./company/playbooks/playbooks.module";
import { IdleTimeOutService } from "./shared/services/idleTimeOut/idle-time-out.service";
import { NgIdleModule } from "@ng-idle/core";
import { IdlePopUpComponent } from "./shared/components/idle-pop-up/idle-pop-up.component";
import { HandleSubDomainRedirectComponent } from "./handle-sub-domain-redirect/handle-sub-domain-redirect.component";
import { SelectLanguageComponent } from "./translation/playbook-translation/contents/select-language/select-language.component";
import { ChallengeCropperModalComponent } from "./company/coaching/shared/components/challenge-cropper-modal/challenge-cropper-modal.component";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { VplaybookLetModuleModule } from "./shared/modules/vplaybook-let-module/vplaybook-let-module.module";
import { VplaybookVideoViewerModule } from "./shared/modules/vplaybook-video-viewer/vplaybook-video-viewer.module";
import { VplaybookAudioPLayerModule } from "./shared/modules/vplaybook-audio-player/vplaybook-audio-player.module";
import { PageTemplateEditorModule } from "./shared/modules/page-template-editor/page-template-editor.module";
import { VideoChunksUploadModule } from "./shared/modules/video-chunks-upload/video-chunks-upload.module";
import { NgxDocViewerModule } from "ngx-doc-viewer";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { CloseCurrentTabComponent } from "./shared/components/close-current-tab/close-current-tab.component";
import { ThankYouPageComponent } from "./shared/components/thank-you-page/thank-you-page.component";
import { ReportModule } from "./company/report/report.module";
import { ReportChartComponent } from "./company/report/shared/report-chart/report-chart.component";
import { PastePageSectionModalModule } from "./shared/modules/paste-page-section-modal/paste-page-section-modal.module";
import { GoogleAnalyticsService } from "./shared/services/google-analytics/google-analytics.service";

export function configFactory() {
  return (window as any).CKEDITOR;
}
export function getBaseUrl() {
  return document.getElementsByTagName("base")[0].href;
}
@NgModule({ declarations: [
        AppComponent,
        TopBarComponent,
        SideBarComponent,
        LoaderComponent,
        UserGuidePreviewComponent,
        ContentNotificationsModalComponent,
        CoverAndColorsModalComponent,
        DuplicatePlaybookModalComponent,
        EditScheduleReportComponent,
        EditresourceComponent,
        ImportExportComponent,
        SelectLanguageComponent,
        EditimageComponent,
        ResourcelandingComponent,
        BrowserSupportComponent,
        IdlePopUpComponent,
        HandleSubDomainRedirectComponent,
        ChallengeCropperModalComponent,
        CloseCurrentTabComponent,
        ThankYouPageComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        OnlineSwitchModule,
        ConfirmationModalModule,
        PastePageSectionModalModule,
        ResourceEmailModule,
        AppViewerSharedModule.forRoot(),
        RichTextEditorComponent,
        BrowserAnimationsModule,
        ToastrModule.forRoot({}),
        NgxScrollbarAppModule,
        ModalModule,
        NavigationModule,
        VBuilderAdminModule,
        UploadResourcesModule,
        BsDatepickerModule,
        ColorPickerModule,
        PopoverModule,
        SafeHtmlPipeModule,
        DndModule,
        DragDropModule,
        NgSelectModule,
        FileUploadModule,
        DateRangePickerV2Module,
        LoadSecureAssetsModule,
        SafePipeModule,
        PageNotFoundModule,
        PlaybooksModule,
        NgIdleModule.forRoot(),
        VplaybookLetModuleModule,
        NgxSliderModule,
        VplaybookAudioPLayerModule,
        VplaybookVideoViewerModule,
        PageTemplateEditorModule,
        VideoChunksUploadModule,
        NgxDocViewerModule,
        PdfViewerModule,
        ReportModule,
        TooltipModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
            deps: [AuthService],
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CustomLoaderService,
            multi: true,
        },
        {
            provide: CK_TOKEN,
            useFactory: configFactory,
        },
        {
            provide: "BASE_URL",
            useFactory: getBaseUrl,
        },
        AuthService,
        TokenInterceptor,
        LocalStorageService,
        RoutebehaviourService,
        CustomLoaderService,
        IdleTimeOutService,
        GoogleAnalyticsService,
        SmoothScrollManager,
        ScrollbarManager,
        TooltipConfig,
        PopoverConfig,
        BsDatepickerConfig,
        BsDatepickerInlineConfig,
        BsDaterangepickerConfig,
        BsDaterangepickerInlineConfig,
        BsLocaleService,
        provideHttpClient(withInterceptorsFromDi()),
        provideNgxWebstorage(
            withNgxWebstorageConfig({ prefix: "ngx-webstorage", separator: "|", caseSensitive: false }),
            withLocalStorage(),
            withSessionStorage(),
        ),
        providePrimeNG({ theme: { preset: Aura } }),
    ] })
export class AppModule {}
